import { useEffect, useRef } from 'react';

const pillars = [
  {
    number: '01',
    icon: 'ri-trophy-line',
    title: 'Consultoria Esportiva',
    description:
      'Assessoria completa para atletas profissionais — gestão de carreira, negociação de contratos e posicionamento internacional no mercado de elite.',
  },
  {
    number: '02',
    icon: 'ri-safe-2-line',
    title: 'Blindagem Patrimonial',
    description:
      'Estruturas jurídicas e financeiras robustas para proteção do patrimônio. Holdings, trusts internacionais e planejamento sucessório sofisticado.',
  },
  {
    number: '03',
    icon: 'ri-bit-coin-line',
    title: 'Operações Financeiras e Cripto',
    description:
      'Operações com criptomoedas, estruturação financeira internacional, diversificação de ativos e estratégias em mercados globais.',
  },
  {
    number: '04',
    icon: 'ri-star-line',
    title: 'Grandes Eventos',
    description:
      'Planejamento e gestão de grandes eventos esportivos e corporativos com padrão internacional de excelência.',
  },
];

const PillarsSection = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.08 }
    );
    ref.current?.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-[#0B0B0D] py-28 lg:py-36">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">

        {/* Header */}
        <div className="reveal opacity-0 translate-y-8 transition-all duration-700 mb-16">
          <span className="font-sans text-xs font-medium tracking-[0.3em] uppercase text-[#C9A96E] block mb-4">
            Áreas de Atuação
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-white">
            Nossos Pilares
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5 rounded-2xl overflow-hidden">
          {pillars.map((pillar, i) => (
            <div
              key={i}
              className="reveal opacity-0 translate-y-8 transition-all duration-700 group bg-[#0B0B0D] p-10 hover:bg-[#0F172A] cursor-pointer"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="flex items-start justify-between mb-8">
                <span className="font-serif text-4xl font-light text-[#C9A96E]/20 leading-none">
                  {pillar.number}
                </span>
                <div className="w-10 h-10 flex items-center justify-center rounded-full border border-white/10 group-hover:border-[#C9A96E]/30 transition-all duration-300">
                  <i className={`${pillar.icon} text-white/40 group-hover:text-[#C9A96E] text-base transition-all duration-300`} />
                </div>
              </div>

              <h3 className="font-serif text-xl font-light text-white mb-4 leading-snug">
                {pillar.title}
              </h3>
              <p className="font-sans text-sm font-light text-white/50 leading-relaxed">
                {pillar.description}
              </p>

              <div className="mt-8 flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <span className="font-sans text-xs tracking-[0.2em] uppercase text-[#C9A96E]">Saiba mais</span>
                <i className="ri-arrow-right-line text-[#C9A96E] text-xs" />
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PillarsSection;
